// Hooks
import useUniqueTableName from '../../hooks/useUniqueTableName';
import useHousingAssistanceVouchersQuery from './hooks.useHousingAssistanceVouchersQuery';
import useRows from './hooks.useRows';
import useModalProps from '../../hooks/useModalProps';
import {
  useTableFilterSortSearchManager,
  useTableFilterSortData,
  useTableManageColumns,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';

import { useHeaders, usePropertyPathMap } from './constants';

const useHousingAssistanceVoucher = ({
  organizationId,
  propertyId,
  householdId,
  stage,
}) => {
  const name = useUniqueTableName('household-housing-assistance-vouchers');
  const {
    data: results,
    isLoading,
    refetch: refetchVouchers,
  } = useHousingAssistanceVouchersQuery({
    organizationId,
    propertyId,
    householdId,
  });

  const headers = useHeaders();
  const propertyPathMap = usePropertyPathMap();

  const {
    filterState,
    filterTypeState,
    dateState,
    order,
    orderBy,
    handleSortChange,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleDateSubmit,
    searchState,
  } = useTableFilterSortSearchManager({
    name,
    initialOrderBy: 'voucherStartDate',
    initialOrder: 'desc',
    headers,
  });

  const filteredResults = useTableFilterSortData({
    results,
    order,
    orderBy,
    filterState,
    filterTypeState,
    searchState,
    dateState,
    PROPERTY_PATH_MAP: propertyPathMap,
  });

  const modalProps = useModalProps();

  const rows = useRows({
    handleOpenModal: modalProps.handleOpen,
    handleOpenConfirmModal: modalProps.handleOpenConfirmModal,
    housingAssistanceVouchers: filteredResults,
    stage,
  });

  const {
    allColumnsHidden,
    columnOptions,
    filteredHeaders,
    selectedColumns,
    handleColumnChange,
  } = useTableManageColumns({
    name,
    headers,
    firstRow: rows[0],
  });

  return {
    modalProps,
    // Table
    handleSortChange,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleDateSubmit,
    isLoading,
    allColumnsHidden,
    columnOptions,
    filteredHeaders,
    selectedColumns,
    handleColumnChange,
    count: rows.length ?? 0,
    totalCount: results?.length ?? 0,
    name,
    order,
    orderBy,
    // Data
    refetchVouchers,
    rows,
  };
};

export default useHousingAssistanceVoucher;
